export default {
  loadingRequest: false,
  billingProcessStatus: null,
  allAccounts: [],
  accountHeaders: [
    {
      text: 'Actions',
      value: 'Actions',
      sortable: false,
      align: 'left'
    },
    {
      text: 'ID',
      value: 'Id',
      sortable: false,
      align: ' d-none'
    },
    {
      text: 'Payer Account ID',
      value: 'PayerAccountId',
      sortable: false,
      align: 'left'
    },
    {
      text: 'Linked Account ID',
      value: 'LinkedAccountId',
      sortable: false,
      align: 'left'
    },
    {
      text: 'Linked Account Name',
      value: 'LinkedAccountName',
      sortable: false,
      align: 'left'
    },
    {
      text: 'Service Period',
      value: 'Service_Period',
      sortable: false,
      align: 'left'
    },
    {
      text: 'CloudCheckr Cost',
      value: 'CloudCheckr_Cost',
      sortable: false,
      align: 'left'
    },
    {
      text: 'AWS Discount',
      value: 'AWS_Discount',
      sortable: false,
      align: 'left'
    },
    {
      text: 'DXC Discount',
      value: 'DXC_Discount',
      sortable: false,
      align: 'left'
    },
    {
      text: 'Additional Discount',
      value: 'Additional_Discount',
      sortable: false,
      align: 'left'
    },
    {
      text: 'Uplift',
      value: 'Uplift',
      sortable: false,
      align: 'left'
    },
    {
      text: 'Credit Backbill',
      value: 'Credit_Backbill',
      sortable: false,
      align: 'left'
    },
    {
      text: 'Total Costs to Allocate',
      value: 'Total_Costs_to_Allocate',
      sortable: false,
      align: 'left'
    },
    {
      text: 'Estimated Monthly Revenue',
      value: 'Estimated_Monthly_Revenue',
      sortable: false,
      align: 'left'
    },
    {
      text: 'Estimated Twelve Month Revenue',
      value: 'Estimated_Twelve_Month_Revenue',
      sortable: false,
      align: 'left'
    },
    {
      text: 'CR Remaining',
      value: 'CR_Remaining',
      sortable: false,
      align: 'left'
    },
    {
      text: 'Service Product',
      value: 'Service_Product',
      sortable: false,
      align: 'left'
    },
    {
      text: 'Can Allocate',
      value: 'Can_Allocate',
      sortable: false,
      align: 'left'
    },
    {
      text: 'WBS',
      value: 'WBS',
      sortable: false,
      align: 'left'
    },
    {
      text: 'WBS End Date',
      value: 'WBS_End_Date',
      sortable: false,
      align: 'left'
    },
    {
      text: 'IWO Number',
      value: 'IWO_Number',
      sortable: false,
      align: 'left'
    },
    {
      text: 'Originating Org WBS',
      value: 'Originating_Org_WBS',
      sortable: false,
      align: 'left'
    },
    {
      text: 'Cost Center',
      value: 'Cost_Center',
      sortable: false,
      align: 'left'
    },
    {
      text: 'Client Name',
      value: 'Client_Name',
      sortable: false,
      align: 'left'
    },
    {
      text: 'Horizon Client Name',
      value: 'Horizon_Client_Name',
      sortable: false,
      align: 'left'
    },
    {
      text: 'Revenue Missing from Horizon',
      value: 'Revenue_Missing_from_Horizon',
      sortable: false,
      align: 'left'
    },
    {
      text: 'Region',
      value: 'Region',
      sortable: false,
      align: 'left'
    },
    {
      text: 'Account Type',
      value: 'Account_Type',
      sortable: false,
      align: 'left'
    },
    {
      text: 'Major Offering Code',
      value: 'Major_Offering_Code',
      sortable: false,
      align: 'left'
    },
    {
      text: 'Major Offering Name',
      value: 'Major_Offering_Name',
      sortable: false,
      align: 'left'
    },
    {
      text: 'SFDC Opp ID',
      value: 'SFDC_Opp_ID',
      sortable: false,
      align: 'left'
    },
    {
      text: 'SFDC Opp Status',
      value: 'SFDC_Opp_Status',
      sortable: false,
      align: 'left'
    },
    {
      text: 'AWS on Opp',
      value: 'AWS_on_Opp',
      sortable: false,
      align: 'left'
    },
    {
      text: 'Financial System',
      value: 'Financial_System',
      sortable: false,
      align: 'left'
    },
    {
      text: 'CR Redeemed from AWS',
      value: 'CR_Redeemed_from_AWS',
      sortable: false,
      align: 'left'
    },
    {
      text: 'CR Used',
      value: 'CR_Used',
      sortable: false,
      align: 'left'
    },
        {
      text: 'Exceptions',
      value: 'Exceptions',
      sortable: false,
      align: 'left'
    },
    {
      text: 'Contract',
      value: 'Contract',
      sortable: false,
      align: 'left'
    },
    {
      text: 'Notes',
      value: 'Notes',
      sortable: false,
      align: 'left'
    },
    {
      text: 'Galaxy Service Level',
      value: 'Galaxy_Service_Level',
      sortable: false,
      align: 'left'
    }

  ],

  customers: [],
  customerHeaders: [
    {
      sortable: true,
      text: 'Customer',
      value: 'Client_Name'
    },
    {
      sortable: true,
      text: '# of Accounts',
      value: 'No_of_Accts'
    }
  ],
  linkedAccounts: [],
  linkedAccountHeaders: [
    {
      sortable: true,
      text: 'Account ID',
      value: 'LinkedAccountId'
    },
    {
      sortable: true,
      text: 'Account Name',
      value: 'Acct_Name'
    }
  ]
}
